module.exports = __webpack_public_path__ + "static/media/Logo-farmageo-borde.7039f4b6.svg";